import protoRoot from "../proto-root";
import createMessage from "./createMessage";

function create(payload) {
  const PairingType = protoRoot.lookupEnum("comm.PairingType");
  const RequestPairingResult = protoRoot.lookupEnum("comm.RequestPairingResult");

  payload.pairingType = PairingType.values[payload.pairingType];
  payload.result = RequestPairingResult.values[payload.result];

  const RequestPairingResponseMessage = protoRoot.lookupType(
    `comm.RequestPairingResponseMessage`
  );
  const requestPairingResponseMessage = RequestPairingResponseMessage.create(
    payload
  );

  return createMessage({ requestPairingResponseMessage });
}

export default {
  create
};
